import { render } from "./GraficoEficienciaHP.vue?vue&type=template&id=2ec45d50&scoped=true"
import script from "./GraficoEficienciaHP.vue?vue&type=script&lang=js"
export * from "./GraficoEficienciaHP.vue?vue&type=script&lang=js"

import "./GraficoEficienciaHP.vue?vue&type=style&index=0&id=2ec45d50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec45d50"]])

export default __exports__